function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback, useState, useEffect, useRef } from 'react';
import { usePrefixCls } from '@byte-design/config';
import { AddOne, DownOne, Loading, ReduceOne, RightOne, Drag } from '../../../common/icons';
import { CascaderState, useCascader } from '../../../hooks/tree';
import { Checkbox } from '../../checkbox';
export function Item(props) {
  var _a, _b;

  var id = props.id,
      isLeaf = props.isLeaf,
      icon = props.icon,
      label = props.label,
      state = props.state,
      expanded = props.expanded,
      showLine = props.showLine,
      loading = props.loading,
      disabled = props.disabled;
  var dragRef = useRef(null);
  var rectRef = useRef();
  var timerRef = useRef();
  var tree = useCascader();
  var handleExpanded = useCallback(function () {
    tree.setExpanded(id, !expanded);
  }, [expanded]);
  var handleSelected = useCallback(function () {
    tree.setItemState(id, state === CascaderState.SELECTED ? CascaderState.UNSELECTED : CascaderState.SELECTED, !expanded);
  }, [state, expanded]);
  var draggable = tree.getDraggable();

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      dragPos = _useState2[0],
      setDragPos = _useState2[1];

  var headInCls = usePrefixCls('tree-node-head-drag-over-in');
  var clsHead = usePrefixCls('tree-node-head', {
    selected: state !== CascaderState.UNSELECTED,
    loading: loading,
    disabled: disabled,
    draggable: draggable,
    'drag-over-in': draggable && dragPos === 0
  });
  var clsLineTop = usePrefixCls('tree-node-head-drag-over-top', {
    expanded: !!((_a = tree.getItemInfo(id).children) === null || _a === void 0 ? void 0 : _a.length),
    show: draggable && dragPos === -1
  });
  var clsLineBottom = usePrefixCls('tree-node-head-drag-over-bottom', {
    expanded: !!((_b = tree.getItemInfo(id).children) === null || _b === void 0 ? void 0 : _b.length),
    show: draggable && dragPos === 1,
    in: draggable && dragPos === 0
  });
  var clsHeadExpandedIcon = usePrefixCls('tree-node-head-expanded-icon');
  var clsHeadCheckbox = usePrefixCls('tree-node-head-checkbox');
  var clsHeadLabelWrapper = usePrefixCls('tree-node-head-label-wrapper');
  var clsHeadLabel = usePrefixCls('tree-node-head-label');
  var clsHeadDragIcon = usePrefixCls('tree-node-head-icon');
  useEffect(function () {
    var _a, _b, _c, _d, _e, _f, _g, _h;

    var parentId = tree.getItemInfo(id).parentId;

    if (dragPos) {
      parentId && ((_d = (_c = (_b = (_a = tree.getItemInfo(parentId)) === null || _a === void 0 ? void 0 : _a.ref) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.firstElementChild) === null || _d === void 0 ? void 0 : _d.classList.add(headInCls));
    } else {
      parentId && ((_h = (_g = (_f = (_e = tree.getItemInfo(parentId)) === null || _e === void 0 ? void 0 : _e.ref) === null || _f === void 0 ? void 0 : _f.current) === null || _g === void 0 ? void 0 : _g.firstElementChild) === null || _h === void 0 ? void 0 : _h.classList.remove(headInCls));
    }
  }, [dragPos]);
  var expandIcon = loading ? React.createElement(Loading, null) : expanded ? showLine ? React.createElement(ReduceOne, null) : React.createElement(DownOne, {
    theme: "filled"
  }) : showLine ? React.createElement(AddOne, null) : React.createElement(RightOne, {
    theme: "filled"
  });
  var onDragStart = useCallback(function (e) {
    var _e$currentTarget$getB = e.currentTarget.getBoundingClientRect(),
        x = _e$currentTarget$getB.x,
        y = _e$currentTarget$getB.y;

    var mouseX = e.clientX - x;
    var mouseY = e.clientY - y;
    e.dataTransfer.setDragImage(dragRef.current, mouseX, mouseY);
    tree.dragStart(id);
    tree.drapMouse(mouseX, mouseY);
  }, [draggable]);
  var onDragEnter = useCallback(function (e) {
    var rect = e.currentTarget.getBoundingClientRect();
    tree.setEnterID(id);
    rectRef.current = rect;
  }, []);
  var onDrop = useCallback(function (v) {
    var _a;

    var dropPostionArray = (_a = tree.getItemInfo(id).position) === null || _a === void 0 ? void 0 : _a.split('-');
    var dropPos = (dropPostionArray === null || dropPostionArray === void 0 ? void 0 : dropPostionArray.length) ? Number(dropPostionArray[(dropPostionArray === null || dropPostionArray === void 0 ? void 0 : dropPostionArray.length) - 1]) + Number(dragPos) : 0;
    dragPos != null && tree.drop(id, dropPos, !!dragPos);
    setDragPos(null);
  }, [draggable, dragPos]);
  var onDragLeave = useCallback(function (e) {
    if (id != tree.getEnterID()) {
      setDragPos(null);
    }
  }, [draggable]);
  var onDragOver = useCallback(function (e) {
    var _a, _b, _c;

    var mouseX = e.clientX - tree.drapMousePos.x;
    var mouseY = e.clientY - tree.drapMousePos.y;
    var x = ((_a = rectRef.current) === null || _a === void 0 ? void 0 : _a.x) || 0;
    var y = ((_b = rectRef.current) === null || _b === void 0 ? void 0 : _b.y) || 0;
    var parentPos = tree.getItemInfo(tree.getDragId()).position;
    var childPos = tree.getItemInfo(id).position;
    e.stopPropagation();
    e.preventDefault();

    if (timerRef.current) {
      return;
    }

    timerRef.current = setTimeout(function () {
      timerRef.current = undefined;
    }, 300);

    if (parentPos && childPos && childPos.startsWith(parentPos)) {
      setDragPos(null);
    } else if ((_c = tree.getItemInfo(id).children) === null || _c === void 0 ? void 0 : _c.length) {
      setDragPos(-1);
      tree.setExpanded(id, true);
    } else if (mouseX - x > 28 + 6) {
      setDragPos(0);
      tree.setExpanded(id, true);
    } else if (mouseY - y < 0) {
      setDragPos(-1);
    } else {
      setDragPos(1);
    }
  }, [draggable]);
  return React.createElement("div", {
    className: clsHead,
    draggable: draggable,
    onDragStart: onDragStart,
    onDragLeave: onDragLeave,
    onDragEnter: onDragEnter,
    onDragOver: onDragOver,
    onDrop: onDrop
  }, React.createElement("div", {
    className: clsLineTop
  }), icon !== undefined && icon !== null ? React.createElement("span", {
    className: clsHeadExpandedIcon,
    onClick: handleExpanded
  }, icon) : !isLeaf && React.createElement("span", {
    className: clsHeadExpandedIcon,
    onClick: handleExpanded
  }, expandIcon), React.createElement("div", {
    className: clsHeadLabelWrapper,
    ref: dragRef
  }, tree.multiple && React.createElement("span", {
    className: clsHeadCheckbox
  }, React.createElement(Checkbox, {
    checked: state === CascaderState.SELECTED,
    indeterminate: state === CascaderState.PARTIAL,
    onClick: handleSelected,
    disabled: disabled
  })), React.createElement("span", {
    className: clsHeadLabel,
    onClick: handleSelected
  }, label), draggable && React.createElement("span", {
    className: clsHeadDragIcon
  }, React.createElement(Drag, null))), React.createElement("div", {
    className: clsLineBottom
  }));
}